module.exports = __webpack_public_path__ + "static/media/shpe_region_2_logo.4a5d8abc.png";